function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { createContext, useContext, useEffect, useState } from 'react';
import { ApiContext } from "./ApiBootstrap.js";
/**
 * Function to fetch an API based on a provided descriptor object.
 * Depending on the context there may be more properties on the descriptor,
 * providing more information about the object, such as a session ID.
 * @param descriptor Descriptor object or URI to fetch the API from.
 * @returns A promise that resolves to the API instance for the provided variable descriptor.
 */
export var DeferredApiContext = /*#__PURE__*/createContext(null);
DeferredApiContext.displayName = 'DeferredApiContext';

/**
 * Retrieve the API for the current context, given the widget provided.
 * The API may need to be loaded, and will return `null` until it is ready.
 * @param widget The widget descriptor or URI to use to fetch the API
 * @returns A tuple with the API instance, and an error if one occurred.
 */
export function useDeferredApi(widget) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    api = _useState2[0],
    setApi = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var deferredApi = useContext(DeferredApiContext);
  var contextApi = useContext(ApiContext);
  useEffect(() => {
    if (deferredApi == null) {
      if (contextApi != null) {
        setApi(contextApi);
        setError(null);
        return;
      }
      setApi(null);
      setError(new Error('No API available in useDeferredApi. Was code wrapped in ApiBootstrap or DeferredApiContext.Provider?'));
      return;
    }
    var isCancelled = false;
    function loadApi() {
      return _loadApi.apply(this, arguments);
    }
    function _loadApi() {
      _loadApi = _asyncToGenerator(function* () {
        if (widget == null) {
          if (!isCancelled) {
            setApi(null);
            setError(new Error('No widget provided to useDeferredApi'));
          }
        } else if (typeof deferredApi === 'function') {
          try {
            var newApi = yield deferredApi(widget);
            if (!isCancelled) {
              setApi(newApi);
              setError(null);
            }
          } catch (e) {
            if (!isCancelled) {
              setApi(null);
              setError(e !== null && e !== void 0 ? e : new Error('Null error'));
            }
          }
        } else {
          setApi(deferredApi);
        }
      });
      return _loadApi.apply(this, arguments);
    }
    loadApi();
    return () => {
      isCancelled = true;
    };
  }, [contextApi, deferredApi, widget]);
  return [api, error];
}
export default useDeferredApi;
//# sourceMappingURL=useDeferredApi.js.map